function handleCalculations($calculator, $table) {
  $calculator.on('success', onCalculationDone($table));
}

function onCalculationDone($table) {
  return () => {
    const sortingDefaults = $table.data('sortingDefaults');

    if (!sortingDefaults) {
      return;
    }

    $table.data('sortingDefaults', null);
    $table.data('sorting', sortingDefaults.split(','));
  };
}

export default handleCalculations;
